/**
 * 成功 key
 */
const ABOUTE_ENUMS = {
    YEARLEADS: 'yearLeads',
    YEARLEADSFINISH: 'yearLeadsFinish',
    DRIVER: 'driver',
    DRIVERFINISH: 'driverFinish',
    APPDRIVER: 'appDriver',
    APPFRIEND: 'appFriend',
    APPFRIENDFELLOW: 'appFriendFellow',
    FRIEND: 'friend', // 新用户
    FRIENDSELF: 'friendSelf', // 自己邀请自己
    FRIENDEMPLOYEE: 'friendEmployee', // 员工
    FRIENDOWNER: 'friendOwner', // 车主
    FRIENDSAMEINVITER: 'friendSameInviter', // 相同邀请人
    FRIENDINVITE: 'friendInvite', // 接受受过了
    LEADS: 'leads',
    LEADSFRIEND: 'leadsFriend',
    LEADSSELF: 'leadsSelf',
    LEADSEMPLOYEE: 'leadsEmployee',
    LEADSOWNER: 'leadsOwner',
    LEADSSAMEINVITER: 'leadsSameInviter',
    LEADSINVITE: 'leadsInvite',
    DEFAULT: 'default'
};

const contents = {
    [ABOUTE_ENUMS.YEARLEADS]: {
        title: '参与成功',
        content:
            '最终获奖名单将于1月22日在蔚来App上公布，请下载App关注@用户大当家查看。<br />我们也会第一时间联系中奖用户，记得保持电话畅通~'
    },
    [ABOUTE_ENUMS.YEARLEADSFINISH]: {
        title: '你已参与过活动',
        content:
            '最终获奖名单将于1月22日在蔚来App上公布，请下载App关注@用户大当家查看。<br />我们也会第一时间联系中奖用户，记得保持电话畅通～'
    },
    [ABOUTE_ENUMS.DRIVER]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。您还可以点击下方配置按钮，试试定制自己的爱车吧。'
    },
    [ABOUTE_ENUMS.DRIVERFINISH]: {
        title: '你已参与过活动',
        content:
            '感谢预约试驾，蔚来工作人员会跟你沟通具体的试驾时间和地点，敬请期待。你也可以前往应用商店下载蔚来App提前体验蔚来愉悦生活方式。'
    },
    [ABOUTE_ENUMS.APPDRIVER]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。'
    },
    [ABOUTE_ENUMS.APPFRIEND]: {
        title: '试驾邀请已发出',
        content: '快快通知好友查收邀请短信，点击短信中的链接并选择“接受邀请”，即可成功预约试驾！'
    },
    [ABOUTE_ENUMS.APPFRIENDFELLOW]: {
        title: '试驾邀请已发出',
        content:
            '感谢邀请好友试驾蔚来汽车。试驾邀请已通过蔚来官方短信平台发出，好友接受邀请后，好友的蔚来顾问会尽快联系你的好友确定具体的试驾时间和地点。'
    },
    [ABOUTE_ENUMS.FRIEND]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：好友已成为您的邀请人，记得跟好友打个招呼哦。'
    },
    [ABOUTE_ENUMS.FRIENDSELF]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您不能接受自己的邀请哦。'
    },
    [ABOUTE_ENUMS.FRIENDEMPLOYEE]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您已是蔚来员工，不能再接受他人邀请哦。'
    },
    [ABOUTE_ENUMS.FRIENDOWNER]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您已是蔚来购车用户，不能再接受他人邀请哦。'
    },
    [ABOUTE_ENUMS.FRIENDSAMEINVITER]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：好友已是您的邀请人，记得跟好友打个招呼哦。'
    },
    [ABOUTE_ENUMS.FRIENDINVITE]: {
        title: '预约成功',
        content:
            '您的专属蔚来顾问会尽快与您联系，跟您确定试驾时间和地点。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您已有邀请人，此次不会再建立新的邀请关系。'
    },
    [ABOUTE_ENUMS.LEADS]: {
        title: '提交成功',
        content: '接下来，您的专属蔚来顾问会尽快与您联系，带您深入了解蔚来。您还可以点击下方配置按钮，试试定制自己的爱车吧。'
    },
    [ABOUTE_ENUMS.LEADSFRIEND]: {
        title: '提交成功',
        content: '接下来，您的专属蔚来顾问会尽快与您联系，带您深入了解蔚来。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：好友已成为您的邀请人，记得跟好友打个招呼哦。'
    },
    [ABOUTE_ENUMS.LEADSSELF]: {
        title: '提交成功',
        content: '接下来，您的专属蔚来顾问会尽快与您联系，带您深入了解蔚来。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您不能接受自己的邀请哦。'
    },
    [ABOUTE_ENUMS.LEADSEMPLOYEE]: {
        title: '提交成功',
        content: '接下来，您的专属蔚来顾问会尽快与您联系，带您深入了解蔚来。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您已是蔚来员工，不能再接受他人邀请哦。'
    },
    [ABOUTE_ENUMS.LEADSOWNER]: {
        title: '提交成功',
        content: '接下来，您的专属蔚来顾问会尽快与您联系，带您深入了解蔚来。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您已是蔚来购车用户，不可再接受他人邀请哦。'
    },
    [ABOUTE_ENUMS.LEADSSAMEINVITER]: {
        title: '提交成功',
        content: '接下来，您的专属蔚来顾问会尽快与您联系，带您深入了解蔚来。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：好友已是您的邀请人，记得跟好友打个招呼哦。'
    },
    [ABOUTE_ENUMS.LEADSINVITE]: {
        title: '提交成功',
        content: '接下来，您的专属蔚来顾问会尽快与您联系，带您深入了解蔚来。您还可以点击下方配置按钮，试试定制自己的爱车吧。<br>提示：您已有邀请人，此次不会再建立新的邀请关系。'
    },
    [ABOUTE_ENUMS.DEFAULT]: {
        title: '提交成功',
        content: '感谢关注蔚来，稍后你的专属蔚来顾问将会与你联系'
    }
};

const configuratorTips = '您还可以点击下方配置按钮，试试定制自己的爱车吧。';

export { contents, configuratorTips, ABOUTE_ENUMS };



// WEBPACK FOOTER //
// ./src/marketing_components/succeed/config.js